var map = {
	"./home-box1-bg-light.png": "c02b",
	"./home-box1-sandbox-light.png": "21ef",
	"./home-customer-choice-light.png": "f7b8",
	"./home-huawei-light.png": "d8d6",
	"./home-meituan-light.png": "9789",
	"./home-midea-light.png": "0891",
	"./home-prc-light.png": "95f9",
	"./home-product-advantage-light.png": "20bb",
	"./home-scdx-light.png": "59eb",
	"./home-selected-report-light.png": "9ea4",
	"./home-service-price-light.png": "c46c",
	"./home-servicePrice-mf-light.png": "fe02",
	"./home-servicePrice-qy-light.png": "71a7",
	"./home-servicePrice-zy-light.png": "4ab5",
	"./home-servicePrice-zyzq-light.png": "e419",
	"./home-typical-scenarios-light.png": "a6a8",
	"./home-wz-light.png": "bd47",
	"./home-yjzx-light.png": "1452",
	"./home-zggs-light.png": "1c6d",
	"./home-zgyd-light.png": "dfdc",
	"./home-zhaoshang-light.png": "2065",
	"./ps-0-light.png": "621c",
	"./ps-1-light.png": "735a",
	"./ps-2-light.png": "cc03",
	"./ps-3-light.png": "be06",
	"./ps-4-light.png": "aba5",
	"./ps-5-light.png": "8d00",
	"./track-bottom-bg-light.png": "57c7",
	"./track-top-bg-light.png": "60ed",
	"./tracked-box1-gap-light.png": "a3b6",
	"./ts-0-light.png": "a143",
	"./ts-1-light.png": "56fc",
	"./ts-2-light.png": "026e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "56fc7";